export enum eAccessControlUserType {
  None = '',
  Admin = 'Admin',
  Vendor = 'Vendor',
  Client = 'Client',
}

export enum eAccessControlUserUrlTypes {
  admin = 'admin',
  vendor = 'vendor',
  client = 'client',
}

export const urlAccessControlUserTypes = Object.values(eAccessControlUserUrlTypes).join('|');

export const mapUrlUserTypeToEnum: Record<eAccessControlUserUrlTypes, eAccessControlUserType> = {
  [eAccessControlUserUrlTypes.admin]: eAccessControlUserType.Admin,
  [eAccessControlUserUrlTypes.vendor]: eAccessControlUserType.Vendor,
  [eAccessControlUserUrlTypes.client]: eAccessControlUserType.Client,
};
